import React from 'react';
import PropTypes from 'prop-types';
import { Navigate, useLocation } from 'react-router-dom';

function AuthRoute({ element, isAuthenticated, showAgreement }) {
  const location = useLocation();

  let parsedShowAgreement = showAgreement;
  if (typeof showAgreement === 'string') {
    try {
      parsedShowAgreement = JSON.parse(showAgreement);
    } catch {
      parsedShowAgreement = false;
    }
  }

  if (isAuthenticated) {
    if (parsedShowAgreement) {
      return <Navigate to="/agreement-terms" replace />;
    } else {
      return (
        <Navigate
          to={
            location.state
              ? {
                  ...location.state.from,
                  state: {
                    ...location.state,
                    fromLogin: location?.pathname === '/login'
                  }
                }
              : { pathname: '/' }
          }
          replace
        />
      );
    }
  }

  // unauthenticated → render the element
  return element;
}

AuthRoute.propTypes = {
  element: PropTypes.node.isRequired,
  isAuthenticated: PropTypes.bool,
  showAgreement: PropTypes.oneOfType([PropTypes.bool, PropTypes.string])
};

export default AuthRoute;
